import { Component, OnInit } from '@angular/core';

import {TranslateService} from '@ngx-translate/core';

@Component({

    selector: 'auth',
    templateUrl: './auth.component.html',
    styleUrls: ['./auth.component.scss']
})
export class AuthComponent implements OnInit {
    constructor(private translate: TranslateService) { }

    ngOnInit() {
        this.closeSideBar();
        
    }
    closeSideBar() {
        $('html').removeClass('nav-open');

        $('.close-layer').remove();
        setTimeout(function () {
            $('.navbar-toggle').removeClass('toggled');
        }, 400);

        
    }
}


// WEBPACK FOOTER //
// ./src/app/auth/auth.component.ts